import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Box } from '@material-ui/core';
import { useSelectedTheme } from '../../../Hooks';

import useStyles from './styles';
function CPP_PropertyDetailsSkeleton({}) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();

  const Divider = () => <Skeleton variant='rect' height={1} width={'100%'} />;

  return (
    <React.Fragment>
      <Box className={styles.propertyDetailsSkeletonPageWrapper}>
        <Box className={styles.basicInfoSekeletonSection}>
          <Skeleton
            key={7}
            variant='rect'
            height={28}
            width={152}
            style={{ marginBottom: 16 }}
          />
          <Divider />
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <>
              <Box key={item} className={styles.fieldWrapper}>
                <Skeleton key={item} variant='rect' height={20} width={220} />
                <Skeleton key={item} variant='rect' height={44} width={512} />
              </Box>
              <Divider />
            </>
          ))}
          <Box key={7} className={styles.fieldWrapper}>
            <Skeleton key={7} variant='rect' height={20} width={220} />
            <div className={styles.mapFieldWrapper}>
              <Skeleton key={7} variant='rect' height={44} width={468} />
              <Skeleton key={7} variant='rect' height={44} width={40} />
            </div>
          </Box>
        </Box>
        <Box className={styles.propertySpecificationSkeletonSection}>
          <Skeleton
            key={8}
            variant='rect'
            height={28}
            width={194}
            style={{ marginBottom: 16 }}
          />
          <Divider />
          {[1, 2, 3, 4].map((item) => (
            <>
              <Box key={item} className={styles.fieldWrapper}>
                <Skeleton key={item} variant='rect' height={20} width={220} />
                <Skeleton key={item} variant='rect' height={44} width={512} />
              </Box>
              {item !== 4 ? <Divider /> : null}
            </>
          ))}
        </Box>
        <Box className={styles.financialInfoSkeletonSection}>
          <Skeleton
            key={9}
            variant='rect'
            height={28}
            width={194}
            style={{ marginBottom: 16 }}
          />
          <Divider />
          {[1, 2, 3].map((item) => (
            <>
              <Box key={item} className={styles.fieldWrapper}>
                <Skeleton key={item} variant='rect' height={20} width={220} />
                <Skeleton key={item} variant='rect' height={44} width={512} />
              </Box>
              {item !== 3 ? <Divider /> : null}
            </>
          ))}
        </Box>
        <Box className={styles.availabilitySkeletonSection}>
          <Skeleton key={1} variant='rect' height={20} width={220} />
          <Box className={styles.availabilitySkeletonSectionOptions}>
            <Skeleton key={1} variant='rect' height={20} width={49} />
            <Skeleton key={2} variant='rect' height={20} width={49} />
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default CPP_PropertyDetailsSkeleton;
